import React, { useRef } from 'react';
import { Waveform } from './Waveform';
import { AudioControlsProps } from './interface';
import { CallType, CustomerCalledSourceType, RecordingFileStatus } from './const';

const AudioControls: React.FC<AudioControlsProps> = ({
  audioUrl,
  metaData,
  type,
  selfCallMetadata
}) => {
  const ref = useRef<any>();

  const isSelfCallExperiment =
    type === CallType.SELF_CALL &&
    selfCallMetadata?.CUSTOMER_CALLED_SOURCE_TYPE === CustomerCalledSourceType.SELF_CALL_EXPERIMENT;

  const isRecordingInProgress =
    selfCallMetadata?.RECORDING_FILE_STATUS === RecordingFileStatus.IN_PROGRESS;

  const isRecordingRecon = selfCallMetadata?.RECORDING_FILE_STATUS === RecordingFileStatus.RECON;

  const isRecordingSuccessButNoUrl =
    selfCallMetadata?.RECORDING_FILE_STATUS === RecordingFileStatus.SUCCESS &&
    selfCallMetadata?.recordingUrl === null;

  if (isSelfCallExperiment) {
    if (isRecordingInProgress) {
      return (
        <div>
          Recording will display <br /> shortly if available
        </div>
      );
    } else if (isRecordingRecon) {
      return <div>No recording found</div>;
    } else if (isRecordingSuccessButNoUrl) {
      return <div>No recording found</div>;
    }
  }

  if (!audioUrl) {
    return <div>No Recording</div>;
  }
  return (
    <div ref={ref} className="audioPlayer">
      <Waveform url={audioUrl} metaData={metaData} />
    </div>
  );
};

export default AudioControls;
